import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder_key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Database types
export interface Database {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
                role: 'CLIENT' | 'FREELANCER' | 'AGENCY' | 'ADMIN';
          status: 'PENDING_VERIFICATION' | 'ACTIVE' | 'SUSPENDED';
          full_name: string;
          email: string;
          phone?: string;
          company?: string;
          company_bulstat?: string;
          bio?: string;
          skills?: string[];
          portfolio_url?: string;
          hourly_rate?: number;
          website_url?: string;
          location?: string;
          timezone?: string;
          avatar_url?: string;
          cover_image_url?: string;
          verified?: boolean;
          verification_documents?: string[];
          rating_avg?: number;
          rating_cnt?: number;
          completed_jobs?: number;
          total_earnings?: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
                role: 'CLIENT' | 'FREELANCER' | 'AGENCY' | 'ADMIN';
          status?: 'PENDING_VERIFICATION' | 'ACTIVE' | 'SUSPENDED';
          full_name: string;
          email: string;
          phone?: string;
          company?: string;
          company_bulstat?: string;
          bio?: string;
          skills?: string[];
          portfolio_url?: string;
          hourly_rate?: number;
          website_url?: string;
          location?: string;
          timezone?: string;
          avatar_url?: string;
          cover_image_url?: string;
          verified?: boolean;
          verification_documents?: string[];
          rating_avg?: number;
          rating_cnt?: number;
          completed_jobs?: number;
          total_earnings?: number;
        };
        Update: {
          role?: 'CLIENT' | 'PROVIDER' | 'ADMIN';
          status?: 'PENDING_VERIFICATION' | 'ACTIVE' | 'SUSPENDED';
          full_name?: string;
          email?: string;
          phone?: string;
          company?: string;
          company_bulstat?: string;
          bio?: string;
          skills?: string[];
          portfolio_url?: string;
          hourly_rate?: number;
          website_url?: string;
          location?: string;
          timezone?: string;
          avatar_url?: string;
          cover_image_url?: string;
          verified?: boolean;
          verification_documents?: string[];
          rating_avg?: number;
          rating_cnt?: number;
          completed_jobs?: number;
          total_earnings?: number;
          updated_at?: string;
        };
      };
      user_credits: {
        Row: {
          id: string;
          user_id: string;
          balance: number;
          lifetime_earned: number;
          lifetime_spent: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          balance?: number;
          lifetime_earned?: number;
          lifetime_spent?: number;
        };
        Update: {
          balance?: number;
          lifetime_earned?: number;
          lifetime_spent?: number;
          updated_at?: string;
        };
      };
      credit_transactions: {
        Row: {
          id: string;
          user_id: string;
          type: 'PURCHASE' | 'BONUS' | 'REFUND' | 'USAGE' | 'ADMIN_ADJUSTMENT';
          amount: number;
          balance_after: number;
          description: string;
          reference_id?: string;
          reference_type?: string;
          metadata?: any;
          created_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          type: 'PURCHASE' | 'BONUS' | 'REFUND' | 'USAGE' | 'ADMIN_ADJUSTMENT';
          amount: number;
          balance_after: number;
          description: string;
          reference_id?: string;
          reference_type?: string;
          metadata?: any;
        };
        Update: {
          type?: 'PURCHASE' | 'BONUS' | 'REFUND' | 'USAGE' | 'ADMIN_ADJUSTMENT';
          amount?: number;
          balance_after?: number;
          description?: string;
          reference_id?: string;
          reference_type?: string;
          metadata?: any;
        };
      };
    };
  };
}
